import { GenericServices } from "./generic.services";
import { CONFIGURATION } from "../common/uri/configuration-uri.constants";
import { ApiResponse } from "../models/app-configuration";
import { commonUri } from "../common";

export class ConfigurationServices extends GenericServices {
    getSystemConfigs(params) {
        return this.executeSelecting(params, `${CONFIGURATION.getSystemConfigs}/info`);
    }

    postSystemConfigs(originalParams, newParams) {
        return this.executeUpdatingCompare(originalParams, newParams, `${CONFIGURATION.getSystemConfigs}`);
    }

    updateSystemConfigs(param: any) {
        return super.executePatch(param, CONFIGURATION.getSystemConfigs)
            .then((response: ApiResponse) => {
                return Promise.resolve()
            })
            .catch(error => Promise.reject(error))
    }

    getGoogleAnalyticsList() {
        return this.executeSelecting({}, `${CONFIGURATION.getListGoogleAnalytics}`).then((res: ApiResponse) => {
            return res.isSuccess ? Promise.resolve(res.data) : Promise.reject(res.message);
        }).catch(err => {
            return Promise.reject(err);
        })
    }

    getConfigValue(configKeys: string[]){
        let url = CONFIGURATION.getValueConfigs;
        url += configKeys.toString();
        return this.executeSelecting({}, url).then((res: ApiResponse) => {
            return res.isSuccess ? Promise.resolve(res.data) : Promise.reject(res.message);
        }).catch(err => {
            return Promise.reject(err);
        })
    }

    async addGoogleAnalytic(payload) {
        try {
            return await this.executeSelectingPost(payload, `${CONFIGURATION.inseGoogleAnalytic}`);
        } catch (error) {
            return error;
        }
    }
    async updateGoogleAnalytic(payload) {
        try {
            return await this.executeSelectingPost(payload, `${CONFIGURATION.updateGoogleAnalytic}`);
        } catch (error) {
            return error;
        }
    }
    async deleteGoogleAnalytic(id) {
        try {
            const url = CONFIGURATION.deleteGoogleAnalytic.replace("{id}", id);
            return await this.executeDeleting(url);
        } catch (error) {
            return error;
        }
    }

    getSitesData() {
        return this.executeSelecting({}, `${commonUri.getSites}`).then((res: ApiResponse) => {
            return res.isSuccess ? Promise.resolve(res.data) : Promise.reject(res.message);
        }).catch(err => {
            return Promise.reject(err);
        })
    }

    getAcaAuthorization() {
        return this.executeSelecting({}, `${commonUri.getAcaAuthorization}`).then((res: ApiResponse) => {
            return res.isSuccess ? Promise.resolve(res.data) : Promise.reject(res.message);
        }).catch(err => {
            return Promise.reject(err);
        })
    }
}